"use client";
import React, { useState } from "react";
import SectionWrapper from "@/components/SectionWrapper";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQ({ faqData = { title: "", questionType: "", faqs: [] } }) {
  const { title, questionType, faqs } = faqData;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <SectionWrapper className="bg-gray-100 p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-4">{title}</h2>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-lg border border-gray-200 transition-transform transform hover:scale-105"
          >
            <h3
              className="text-lg font-semibold cursor-pointer flex justify-between items-center p-4 hover:bg-gray-50"
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-gray-800">{questionType} #{index + 1}: {faq.question}</span>
              <span className="ml-2 text-xl text-gray-600">
                {openIndex === index ? "−" : "+"}
              </span>
            </h3>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <p className="mt-2 mx-4 mb-4 text-gray-700">{faq.answer}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
